import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function CommentColorIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 31 24'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_1439_28704)'>
        <path
          d='M1.10903e-05 22.673C0.311715 21.8382 0.527785 20.9728 0.799935 20.125C0.922137 19.7431 1.02722 19.3576 1.15414 18.9745C1.18893 18.8786 1.20307 18.7764 1.19565 18.6747C1.18822 18.5729 1.15939 18.4739 1.11105 18.3841C0.447832 17.0431 0.125434 15.5593 0.172395 14.0639C0.318801 9.35887 3.74281 5.75303 7.92425 5.0145C8.06666 4.99456 8.20363 4.94625 8.32703 4.87243C8.45044 4.79861 8.55778 4.70078 8.6427 4.58473C10.4728 2.25935 12.8342 0.747471 15.7422 0.222652C19.8505 -0.516464 23.4451 0.586896 26.4275 3.5286C28.2954 5.37226 29.3852 7.62974 29.7583 10.2208C30.1095 12.6554 29.6992 14.9784 28.6159 17.1816C28.5696 17.2657 28.5414 17.3585 28.5329 17.4542C28.5245 17.5498 28.5361 17.6462 28.5669 17.7371C29.0646 19.3558 29.554 20.9769 30.0481 22.5968C30.1266 22.8548 30.1739 23.1128 30.0853 23.3749C29.9165 23.8714 29.4259 24.1087 28.868 23.9475C28.087 23.722 27.3113 23.4806 26.5338 23.2444C25.6252 22.9688 24.7161 22.6942 23.8093 22.4121C23.7354 22.3887 23.6574 22.3811 23.5804 22.3896C23.5033 22.3982 23.4289 22.4227 23.3618 22.4616C21.5984 23.3579 19.6381 23.7968 17.6609 23.738C16.3763 23.7074 15.1062 23.4595 13.9045 23.0048C13.8017 22.9626 13.6914 22.9418 13.5804 22.9437C13.4693 22.9457 13.3598 22.9702 13.2586 23.016C10.6705 24.0609 8.10804 23.9967 5.57112 22.8235C5.47777 22.7743 5.37545 22.7443 5.27026 22.7355C5.16508 22.7267 5.05919 22.7391 4.95893 22.7722C3.7623 23.1441 2.56212 23.503 1.36195 23.8649C0.688361 24.068 0.347725 23.9298 -0.000579834 23.3176L1.10903e-05 22.673ZM27.7328 21.6393C27.7611 21.5118 27.7174 21.4321 27.6926 21.3494C27.3337 20.1593 26.9842 18.9662 26.6099 17.7808C26.55 17.6107 26.5282 17.4295 26.5461 17.2501C26.564 17.0706 26.621 16.8973 26.7132 16.7424C27.7346 14.9087 28.1389 12.947 27.9264 10.8572C27.6903 8.4704 26.718 6.41304 24.9989 4.7642C22.3317 2.20681 19.1409 1.32542 15.5498 2.19736C10.4598 3.43178 7.2424 8.49756 8.18282 13.6666C9.38654 20.2868 16.7346 23.8555 22.6717 20.6847C23.1883 20.409 23.6399 20.3748 24.1771 20.5501C25.3495 20.9321 26.5338 21.275 27.7328 21.6393ZM11.2857 21.6871C11.157 21.5797 11.0938 21.5206 11.0242 21.4704C9.62378 20.4536 8.46279 19.1427 7.62258 17.6296C6.63272 15.8715 6.11586 13.8867 6.12251 11.869C6.115 10.3766 6.39812 8.89705 6.95608 7.51286C6.98678 7.43611 7.07415 7.34579 7.00094 7.27081C6.91357 7.18167 6.81794 7.28203 6.73411 7.3145C6.35947 7.4598 6.00065 7.64297 5.66322 7.86116C3.4258 9.32109 2.1967 11.3708 2.07568 14.0533C2.0131 15.446 2.34015 16.7542 3.02023 17.9709C3.11119 18.1273 3.16668 18.3018 3.18279 18.4821C3.19891 18.6623 3.17526 18.8439 3.1135 19.014C2.9057 19.6563 2.71443 20.3039 2.52316 20.9521C2.46412 21.1528 2.36967 21.3477 2.36554 21.5909C3.2363 21.3282 4.08227 21.0861 4.91879 20.8134C5.30311 20.6882 5.64551 20.7195 5.98555 20.9244C6.32482 21.1207 6.68226 21.2838 7.05289 21.4114C8.40951 21.9055 9.79624 21.9628 11.2857 21.6871Z'
          fill='url(#paint0_linear_1439_28704)'
        />
        <path
          d='M17.995 12.8106C16.6337 12.8106 15.2721 12.8106 13.9104 12.8106C13.5261 12.8106 13.2285 12.6447 13.0426 12.3059C12.8655 11.9853 12.8879 11.6654 13.0863 11.3613C13.1522 11.2516 13.2419 11.1581 13.3488 11.0876C13.4556 11.0171 13.5769 10.9714 13.7038 10.954C13.878 10.9295 14.0538 10.9165 14.2298 10.915C16.7572 10.9127 19.2845 10.9127 21.8116 10.915C21.9584 10.9141 22.1051 10.9248 22.2502 10.9469C22.7756 11.0307 23.111 11.4487 23.0673 11.9564C23.0437 12.1927 22.932 12.4114 22.7545 12.569C22.5769 12.7267 22.3465 12.8117 22.1091 12.8071C20.7377 12.8148 19.3664 12.8106 17.995 12.8106Z'
          fill='url(#paint1_linear_1439_28704)'
        />
        <path
          d='M18.0292 7.59787C19.3807 7.59787 20.7318 7.59787 22.0826 7.59787C22.667 7.59787 23.0738 7.98336 23.0726 8.52707C23.0714 9.07078 22.6593 9.45805 22.0767 9.45864C19.3646 9.461 16.6525 9.461 13.9405 9.45864C13.3696 9.45864 12.9369 9.0578 12.928 8.53652C12.9204 7.9993 13.3525 7.59787 13.9464 7.59728C15.3058 7.5961 16.6667 7.59629 18.0292 7.59787Z'
          fill='url(#paint2_linear_1439_28704)'
        />
        <path
          d='M16.6083 16.1615C15.7363 16.1615 14.865 16.1615 13.9936 16.1615C13.3738 16.1615 12.9363 15.7736 12.9245 15.2281C12.9127 14.6826 13.3513 14.2629 13.9659 14.2605C15.7369 14.2523 17.5091 14.2523 19.2825 14.2605C19.7743 14.2605 20.1185 14.5162 20.2531 14.9264C20.3136 15.1089 20.3159 15.3057 20.2596 15.4895C20.2033 15.6734 20.0913 15.8351 19.939 15.9525C19.7383 16.1113 19.5045 16.1638 19.2518 16.1632C18.3705 16.1603 17.4891 16.1615 16.6083 16.1615Z'
          fill='url(#paint3_linear_1439_28704)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1439_28704'
          x1='-0.000579834'
          y1='0.000244141'
          x2='31.2111'
          y2='1.49533'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1439_28704'
          x1='-0.000579834'
          y1='0.000244141'
          x2='31.2111'
          y2='1.49533'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1439_28704'
          x1='-0.000579834'
          y1='0.000244141'
          x2='31.2111'
          y2='1.49533'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1439_28704'
          x1='-0.000579834'
          y1='0.000244141'
          x2='31.2111'
          y2='1.49533'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <clipPath id='clip0_1439_28704'>
          <rect width='30.1343' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
